import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { DmBackgroundPattern } from '@digitale-menschen/component-library-angular';
import { LexplusLogoComponent } from '@lexplus-shared-lib';

/**
 * Shared layout (background, logo, router outlet) for every auth page.
 * Reused by both apps (user/admin) through AuthPagesRoutes.
 */
@Component({
  selector: 'lp-auth-layout',
  imports: [RouterOutlet, NgOptimizedImage, DmBackgroundPattern, LexplusLogoComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent {}
